// @flow
/* eslint-disable import/prefer-default-export */
import Raven from 'raven-js';
import type { Saga, CallEffect } from 'redux-saga';

import { call, cancelled } from 'redux-saga/effects';
import { BackendError } from 'common/network';

/**
 * Trapped Call Saga
 *
 * Use it for reduce your code in sagas and capture errors
 * This function wrapped you call effect with try/catch statement and capture only important errors
 *
 * @param {CallEffect} callFn
 * @param {Saga} resultSaga
 * @returns {CallEffect}
 */
export function trappedCall<R>(
  callEffect: CallEffect<any, (...args: any[]) => Promise<R>, any>,
  resultSaga?: (err: ?(Error | BackendError), result: R) => Saga<*>,
): CallEffect<*, *, *> {
  return call(function* trapSaga() {
    try {
      const result = yield callEffect;
      if (typeof resultSaga === 'function') {
        return yield call(resultSaga, null, result);
      }
    } catch (err) {
      if (yield cancelled()) {
        return undefined;
      }

      if (err.status == null) {
        Raven.captureException(err);
      }

      if (typeof resultSaga === 'function') {
        return yield call(resultSaga, err, null);
      }
    }

    return undefined;
  });
}

export default trappedCall;



// WEBPACK FOOTER //
// ./src/store/helpers/trappedCall.js